import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;

  .subHeader {
    display: flex;
    gap: 1rem;
    align-items: center;

    h1 {
      color: #b10000;
      font-size: 1.3rem;
      margin: 0;
    }
  }

  .deleteIcon {
    height: 2rem;
    fill: #b10000;
  }

  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const ContentModal = styled.div`
  h2 {
    margin: 1rem 0 0 0;
    font-size: 1.2rem;
    color: ${({ theme }) => theme.colors.text};
    font-weight: lighter;
  }

  p {
    color: ${({ theme }) => theme.colors.primary};
  }

  .buttonModal {
    display: flex;
    justify-content: space-between;
    margin: 2rem 1rem 0 0;
  }
`;
